export default __webpack_public_path__ + "static/media/icon-cobertura-telhado.cfbed7d1.svg";